import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import orderBy from 'lodash/orderBy';
import partition from 'lodash/partition';
import { Button, TrainingModules } from 'shared/components';

import './TrainingDashboard.scss';

const splitModules = (modules) => {
  const [completed, toDo] = partition(modules, (module) =>
    module.submodules.every((submodule) => {
      submodule.completed = submodule.tasks.every((task) => task.completed);
      return submodule.completed;
    })
  );

  return {
    completed,
    toDo,
  };
};

class TrainingDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modules: props.modules ? splitModules(orderBy(props.modules, ['position'])) : [],
      show: 'toDo',
    };

    this.showCompleted = this.showCompleted.bind(this);
    this.showToDo = this.showToDo.bind(this);
  }

  showCompleted() {
    this.setState({
      show: 'completed',
    });
  }

  showToDo() {
    this.setState({
      show: 'toDo',
    });
  }

  render() {
    const { modules } = this.state;
    return modules ? (
      <React.Fragment>
        <div className="buttons-container">
          <Button
            type={this.state.show === 'completed' ? 'btn-outline btn-primary' : 'btn-primary'}
            className="btn-selector w-50 m-0"
            text={this.props.t('training.labelToDo', { number: modules.toDo.length })}
            onClick={this.showToDo}
          />
          <Button
            type={this.state.show === 'toDo' ? 'btn-outline btn-primary' : 'btn-primary'}
            className="btn-selector w-50 m-0"
            onClick={this.showCompleted}
            text={this.props.t('training.labelCompleted', { number: modules.completed.length })}
          />
        </div>
        <div>
          <TrainingModules
            modules={modules[this.state.show]}
            completedAll={modules.toDo.length === 0}
          />
        </div>
      </React.Fragment>
    ) : null;
  }
}

TrainingDashboard.propTypes = {
  modules: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TrainingDashboard);
